module.exports = __webpack_public_path__ + "img/canvas-bg10.0ea13e41.png";